module.exports = __webpack_public_path__ + "static/media/highlights-off.b6cf20a2.svg";